import {
  Injectable
} from '@angular/core';

import {BehaviorSubject} from 'rxjs';

@Injectable()
export class AppointmentService extends BehaviorSubject<any> {

  constructor() {
    super(null);

    this.subscribe(appointment => {
      if( appointment ) {
        localStorage.setItem('appointment', JSON.stringify(appointment));
      }
    });

    this.next(JSON.parse(localStorage.getItem('appointment')));
  }

  clear() {
    localStorage.removeItem('appointment');
    console.log("Remove appointment from local storage.");
    this.next(null);
  }
}
